export default __webpack_public_path__ + "static/media/mail-opened.28e3033a.svg";